(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function overrideSlideshowNavigation() {
      const slideshow = document.querySelector('.image-slideshow-section slideshow-component');
      if (!slideshow || !slideshow.slides) return;

      slideshow.next = function(event, options) {
        event?.preventDefault();
        const current = this.current;
        const nextIndex = current + 1;
        if (nextIndex < (this.slides?.length || 0)) {
          this.select(nextIndex, event, options);
        }
      };

      slideshow.previous = function(event, options) {
        event?.preventDefault();
        const current = this.current;
        const previousIndex = current - 1;
        if (previousIndex >= 0) {
          this.select(previousIndex, event, options);
        }
      };
    }

    overrideSlideshowNavigation();

    setTimeout(overrideSlideshowNavigation, 100);

    document.addEventListener('DOMContentLoaded', overrideSlideshowNavigation);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
